<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/audit-task-setting/table">审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>审单系统配置</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">操作日志</template>
      <el-table
        :data="sortedLogs"
        stripe
        highlight-current-row
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column prop="date" label="时间" min-width="160" />
        <el-table-column prop="operator" label="操作者" min-width="120" />
        <el-table-column label="操作类型" min-width="120">
          <template slot-scope="scope">
            {{ getLogTypeLabel(scope.row.type) }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination" v-if="!loading && (!sortedLogs || sortedLogs.length === 0)">
        <el-empty description="暂无日志" />
      </div>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      logs: [],
    }
  },
  computed: {
    sortedLogs () {
      const list = this.logs || []
      return list
        .slice()
        .sort((a, b) => new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime())
    },
  },
  created () {
    this.fetchLog()
  },
  methods: {
    ...request.map([
      'getAuditTaskSetting',
    ]),
    fetchLog () {
      const id = this.$route.params.id
      this.loading = true
      request.common('getAuditTaskSetting', { id }).then(({ data }) => {
        this.logs = data.logs || []
      }).finally(() => {
        this.loading = false
      })
    },
    getLogTypeLabel (type) {
      const t = type === null || type === undefined ? '' : String(type)
      if (t === 'create') return '创建'
      if (t === 'update') return '更新'
      if (t === 'enable') return '启用'
      if (t === 'disable') return '禁用'
      return t
    },
  },
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/audit-task-setting/pages/AuditTaskSettingLogPage.vue